/**
 * Типизированная версия Object.values
 *
 * @param obj Объект, значения которого нужно получить
 * @typeParam T Тип объекта
 * @returns Массив значений объекта
 */
export function values(obj) {
    // Исправить при редактировании. Автоматический игнор, см. DIRECT-194060.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- см. выше
    return Object.values(obj);
}
